<template>
  <div>
    <div class="overflow-hidden">
      <div class="float-left" style="width: 128px; overflow-y: auto">
        <div class="pt-6" style="min-height: calc(100vh - 135px)">
          <Menu :selectedKeys="[0]"></Menu>
        </div>
      </div>
      <div class="float-right p-6" style="width: calc(100% - 128px)">
        <div class="info">
          <div class="pt-6 step-form-form">
            <a-steps :current="current">
              <a-step title="填写信息" />
              <a-step title="完成" />
            </a-steps>
          </div>
          <div class="mt-6">
            <div v-show="current === 0">
              <Step1
                @next="handleStepNext"
                :reopen="reopen"
                :companyp="company"
              />
            </div>
            <div v-show="current === 1">
              <Step2 :ct="ct" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '@/views/admin/menu/index';
import permission from '@/utils/permission';
import { mapGetters } from 'vuex';
import Step1 from './step/step1.vue';
import Step2 from './step/step2.vue';
// import { contract } from '@/api/contract';
export default {
  components: {
    Menu,
    Step1,
    Step2,
  },
  data() {
    return {
      ct: {},
      current: 0,
      reopen: 0,
    };
  },
  computed: {
    ...mapGetters(['companys']),
    company() {
      return this.companys ? this.companys[0] : {};
    },
  },
  async activated() {
    this.reopen++;
    this.current = 0;
    // this.ct = await contract(2311);
  },
  methods: {
    permission,
    handleStepNext(record) {
      this.ct = record;
      this.current++;
    },
  },
};
</script>
<style scoped>
.info {
  background: #ffffff;
  min-height: calc(100vh - 276px);
}
.step-form-form {
  width: 750px;
  margin: 0 auto 0 auto;
}
</style>
